module.exports = __webpack_public_path__ + "img/authcore-migration-banner-artwork.3bb9271.svg";